import { Chip, alpha } from "@mui/material";
import { Article, UploadFile } from "@mui/icons-material";
import { teal } from "@mui/material/colors";
import { makeStyles, useTheme } from "@/compat/muiStyles";

const useStyles = makeStyles(() => ({
  chip: {
    fontWeight: 600,
    "& .MuiChip-icon": { color: "inherit" },
  },
}));

// Shows whether a risk assessment was uploaded as a document or built from a template.
export default function RiskAssessmentSourceBadge({ isUploaded }: { isUploaded?: boolean }) {
  const classes = useStyles();
  const theme = useTheme();

  const entry = isUploaded
    ? { label: "Uploaded", Icon: UploadFile, color: theme.palette.secondary.main }
    : { label: "Template", Icon: Article, color: teal[600] };

  const { Icon } = entry;

  return (
    <Chip
      size="small"
      variant="outlined"
      className={classes.chip}
      icon={<Icon fontSize="small" />}
      label={entry.label}
      style={{ color: entry.color, borderColor: alpha(entry.color, 0.5) }}
    />
  );
}
